import React from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";

const NotFound = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        mt: 8,
        mb: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontFamily: '"Oswald", sans-serif',
          fontSize: { xs: "3rem", sm: "4rem", md: "5rem" },
          fontWeight: 500,
          mb: 2,
        }}
      >
        404
      </Typography>

      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontFamily: '"Oswald", sans-serif',
          mb: 4,
        }}
      >
        PAGE NOT FOUND
      </Typography>

      <Box
        sx={{
          mb: 4,
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(40, 44, 52, 0.3)",
            zIndex: 1,
            borderRadius: "8px",
          },
        }}
      >
        <img
          src="https://i.imgur.com/GOsD35z.gif"
          alt="Confused Vincent Vega"
          style={{
            maxWidth: "100%",
            height: "auto",
            borderRadius: "8px",
            position: "relative",
            zIndex: 0,
          }}
        />
      </Box>

      <Typography
        variant="h6"
        component="p"
        sx={{
          mb: 4,
          maxWidth: "600px",
        }}
      >
        Looks like you're lost in the wrong part of town. The page you're
        looking for doesn't exist or has been moved.
      </Typography>

      <Button
        variant="contained"
        component={Link}
        to="/"
        startIcon={<HomeIcon />}
        sx={{
          backgroundColor: "#c4d4e0",
          "&:hover": {
            backgroundColor: "#848d94",
          },
          textTransform: "none",
          padding: "10px 24px",
          fontSize: "1rem",
          color: "#282c34",
          fontWeight: 600,
          clipPath: "polygon(10% 0, 100% 0, 100% 66%, 90% 100%, 0 100%, 0 34%)",
        }}
      >
        Back to Home
      </Button>
    </Container>
  );
};

export default NotFound;
